import { PropsWithChildren } from 'react';

export const DottedWrapperHero = ({ children }: PropsWithChildren) => {
  return (
    <div className="bg-[url('/src/assets/BackgroundGrey.svg')] bg-no-repeat bg-top">
      {children}
    </div>
  );
};
